import React from "react";
import { sectionSpacingY } from "components/section";
import { HightouchCdpFeaturesAccordion } from "components/content";

export function CdpAccordion() {
  return (
    <HightouchCdpFeaturesAccordion
      title="The only Customer Data Platform that closes the marketing loop"
      description="Stop jumping between tools and trying to tie your data together between systems. Simplify your workflow with end-to-end tools built for marketers."
      mt={sectionSpacingY}
    />
  );
}
